import React, { useRef, useState } from 'react';
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { useSelector } from 'react-redux';
import {
  Card,
  CardContent,
  Input,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Dialog, DialogActions, DialogContent, DialogTitle,
} from "@material-ui/core";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import ReactToPrint from 'react-to-print';
import { MdPrint } from "react-icons/md";
import HttpService from '../../services/httpService';
import moment from 'moment';

const cellStyle = {
  center: {
    borderRight: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    padding: '6px',
    textAlign: 'center'
  },
  left: {
    borderRight: '1px solid #ddd',
    borderBottom: '1px solid #ddd',
    padding: '6px',
    textAlign: 'left'
  },
  remarks: {
    borderBottom: '1px solid #ddd',
    padding: '6px'
  }
};

const checklistPoints = [
    "Cover Page With All Details Are Filled And Correct",
    "Floor Plan With Furniture Layout With Scope Of Work Present And Correct",
    "Laminate Tabular Sheet Is Present And Correct As Per MOM's",
    "Hatching Details Matching With 2D And 3D",
    "Check For Vertical And Horizontal Dimensions Individual And Overall (Including Filler, Skirting, Cover Panel) (Not Required To Check As Per Site QC)",
    "Handle Details Are Mentioned",
    "Tape Masking - Site Image Attached",
    "Non-Standard Laminate/Acrylic/Hardware/Accessories If Any Approval Received",
    "Line Items In The Quotation To Be Reflected In The 2D Along With The Materials/Finishes",
    "2D And Quotation To Be Segregated Areawise",
    "Hardware/Accessories Used Are As Per Standards Only",
    "Jaali Used Are As Per Standards",
    "SC And SH To Be Segregated Areawise In The Quotation"
  ];

const AdmCheckList = (props) => {
  const checklistRef = useRef();

  // State to handle the checkbox checked states
  const [checkboxStates, setCheckboxStates] = useState(Array(checklistPoints.length).fill(false));
  // State to handle textarea values
  const [remarks, setRemarks] = useState(Array(checklistPoints.length).fill(''));
  const { userDetails } = useSelector(state => state.user);
  const [openRejectPopup, setOpenRejectPopup] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');



  const handleCheckboxChange = (index) => {
    const updatedCheckboxStates = [...checkboxStates];
    updatedCheckboxStates[index] = !updatedCheckboxStates[index];
    setCheckboxStates(updatedCheckboxStates);
  };

  const handleRemarksChange = (index, value) => {
    const updatedRemarks = [...remarks];
    updatedRemarks[index] = value;
    setRemarks(updatedRemarks);
  };

  const approvalOrRejctDrawingQc = async (e, name) => {
    props.setShowChecklist(false);
    try {
      const obj = {
        type: name,
        data: props.data,
        DesignerSignature: userDetails._id,
        DesignerName: userDetails.name,
        aDMChecklist: checkboxStates,
        aDMCheckRemarks: remarks,
        admRejectedRemarks: rejectionReason,
      }

      const response = await HttpService.drawingQCApprove(obj);
      props.setApprovalMsg(response);
    } catch (error) {
      console.error(error)
      props.setSnackInfo("Something went wrong", 'error');
    }
  }

  return (
    <>
      <div style={{ fontFamily: 'Arial, sans-serif', padding: "20px", backgroundColor: '#f8f9fa' }}>
        <div
          ref={checklistRef}
          style={{
            margin: 'auto',
            backgroundColor: 'white',
            border: "1px solid #ddd",
            borderRadius: "10px",
            padding: "30px",
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img
              src="https://www.decorpot.com/images/decorpot-home-interior-designers-logo.png"
              alt="Decorpot Logo"
              style={{ maxWidth: "200px", height: "auto" }}
            />
            <ReactToPrint
              trigger={() => (
                <MdPrint
                  size={28}
                  style={{ cursor: 'pointer', color: '#F47E46' }}
                  title="Print"
                />
              )}
              content={() => checklistRef.current}
            />
          </div>

          <div
            style={{
              textAlign: 'center',
              backgroundColor: '#F47E46',
              color: 'white',
              border: '2px solid #F47E46',
              borderRadius: '8px',
              margin: '20px 0'
            }}
          >
            <h1 style={{ fontSize: "26px", fontWeight: "bold", margin: 0 }}>ADM CHECKLIST</h1>
          </div>

          <Card style={{ marginBottom: 20 }}>
            <CardContent>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>

                {/* Project No */}
                <div style={{ flex: '1 1 45%' }}>
                  <div style={{ fontWeight: "600", marginBottom: 5 }}>Project No</div>
                  <Input
                    fullWidth
                    disableUnderline
                    value={props.data?.erpProjectNo || ''}
                    disabled
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '0',
                      boxSizing: 'border-box',
                      color: "black",
                    }}
                  />
                </div>

                {/* Client Name */}
                <div style={{ flex: '1 1 45%' }}>
                  <div style={{ fontWeight: "600", marginBottom: 5 }}>Client Name</div>
                  <Input
                    fullWidth
                    disableUnderline
                    value={props.data?.customerId?.name || ''}
                    disabled
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '0',
                      boxSizing: 'border-box',
                      color: "black",
                    }}
                  />
                </div>

                {/* Designer */}
                <div style={{ flex: '1 1 45%' }}>
                  <div style={{ fontWeight: "600", marginBottom: 5 }}>Designer</div>
                  <Input
                    fullWidth
                    disableUnderline
                    value={props.data?.raisedQCDesigner?.name || ''}
                    disabled
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '0',
                      boxSizing: 'border-box',
                      color: "black",
                    }}
                  />
                </div>

                {/* Date */}
                <div style={{ flex: '1 1 45%' }}>
                  <div style={{ fontWeight: "600", marginBottom: 5 }}>Date</div>
                  <Input
                    fullWidth
                    disableUnderline
                    value={moment().format('DD-MM-YYYY')} 
                    disabled
                    style={{
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '0',
                      boxSizing: 'border-box',
                      color: "black",
                    }}
                  />
                </div>

              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent style={{ padding: 0 }}>
              <div style={{ overflowX: 'auto' }}>
                <Table style={{ minWidth: '100%', borderCollapse: 'collapse' }}>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#f1f1f1' }}>
                      <TableCell style={{ fontWeight: 'bold', width: '5%', textAlign: 'center', borderRight: '1px solid #ddd' }}>SL NO</TableCell>
                      <TableCell style={{ fontWeight: 'bold', width: '50%', textAlign: 'center', borderRight: '1px solid #ddd' }}>POINTS TO BE CHECKED</TableCell>
                      <TableCell style={{ fontWeight: 'bold', width: '5%', textAlign: 'center', borderRight: '1px solid #ddd' }}>STATUS</TableCell>
                      <TableCell style={{ fontWeight: 'bold', textAlign: 'center', width: '40%' }}>REMARKS</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {checklistPoints.map((point, index) => (
                      <TableRow key={index}>
                        <TableCell style={cellStyle.center}>{index + 1}</TableCell>
                        <TableCell style={cellStyle.left}>{point}</TableCell>
                        <TableCell style={cellStyle.center}>
                          <Checkbox
                            color="primary"
                            checked={checkboxStates[index]}
                            onChange={() => handleCheckboxChange(index)}
                          />
                        </TableCell>
                        <TableCell style={cellStyle.remarks}>
                          <TextareaAutosize
                            minRows={2}
                            placeholder="Remarks"
                            value={remarks[index]}
                            onChange={(e) => handleRemarksChange(index, e.target.value)}
                            disabled={!checkboxStates[index]}
                            style={{
                              width: '100%',
                              padding: '6px',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              fontSize: '13px',
                              resize: 'vertical',
                              boxSizing: 'border-box',
                              backgroundColor: !checkboxStates[index] ? '#f0f0f0' : 'white'
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>

          <div style={{ flex: '1 1 45%', display: 'flex', alignItems: 'center', marginBottom: '10px', marginTop: "10px" }}>
            <div style={{ fontWeight: 600, marginRight: '10px', whiteSpace: 'nowrap', width: '120px' }}>
                Design Manager
            </div>
            <Input
                fullWidth
                disableUnderline
                value={userDetails.name}
                style={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '4px 8px',
                boxSizing: 'border-box',
                color: 'black',
                flex: 1,
                marginLeft: '20px',
                }}
            />
            </div>

            <p style={{
                fontSize: '12px',
                color: '#888',
                fontStyle: 'italic',
                marginTop: '20px',
                textAlign: 'center'
            }}>
                Note: Document Shared On Or Before 7 PM Of The Previous Day Will Be Considered For Current Day Slot
            </p>
        </div>

        {/* This is approve and reject button for ADM */}
        <div className="no-print" style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px' }}>
          <button
              onClick={(e) => approvalOrRejctDrawingQc(e, 'ADM Completed')}
              disabled={
                !checkboxStates.every((checked, idx) => checked && remarks[idx].trim() !== '')
              }
              style={{
                backgroundColor: 'green',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: checkboxStates.every((checked, idx) => checked && remarks[idx].trim() !== '') ? 'pointer' : 'not-allowed',
                opacity: checkboxStates.every((checked, idx) => checked && remarks[idx].trim() !== '') ? 1 : 0.6,
              }}
>  
              Approve
            </button>
            <button
                // onClick={(e) => approvalOrRejctDrawingQc(e, 'ADM Rejected')}
                onClick={() => setOpenRejectPopup(true)}
                // disabled={!checkboxStates.includes(true)}
                style={{
                backgroundColor: 'red',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                fontSize: '16px',
                // cursor: (!checkboxStates.includes(true)) ? 'not-allowed' : 'pointer',
                cursor:'pointer',
                // opacity: (!checkboxStates.includes(true)) ? 0.6 : 1,
                }}
            >
                Reject
            </button>
        </div>
      </div>

      <Dialog
        open={openRejectPopup}
        onClose={() => setOpenRejectPopup(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '10px 20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
            backgroundColor: '#ffffff',
          }
        }}
      >
        <DialogTitle
          style={{
            fontWeight: 'bold',
            fontSize: '20px',
            color: '#333',
            borderBottom: '1px solid #eee',
            paddingBottom: '10px',
            marginBottom: '10px'
          }}
        >
          Reason for Rejection
          </DialogTitle>

          <DialogContent style={{ padding: '10px 0' }}>
            <TextareaAutosize
              minRows={5}
              placeholder="Please specify the reason for rejection..."
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                fontSize: '14px',
                fontFamily: 'inherit',
                resize: 'vertical',
                boxSizing: 'border-box',
                outline: 'none',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = '#F47E46'}
              onBlur={(e) => e.target.style.borderColor = '#ccc'}
            />
          </DialogContent>

          <DialogActions style={{ justifyContent: 'space-between', padding: '10px 0' }}>
            <button
              onClick={() => setOpenRejectPopup(false)}
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'blue',
                color: 'white',
                padding: '10px 18px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                transition: 'background-color 0.3s',
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#5a6268'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#6c757d'}
            >
              Cancel
            </button>

            <button
              onClick={(e) => {
                approvalOrRejctDrawingQc(e, 'ADM Rejected');
                setOpenRejectPopup(false);
              }}
              disabled={!rejectionReason.trim()}
              style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: !rejectionReason.trim() ? '#ccc' : 'green',
                color: 'white',
                padding: '10px 18px',
                border: 'none',
                borderRadius: '6px',
                cursor: !rejectionReason.trim() ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 500,
                transition: 'background-color 0.3s',
              }}
              onMouseOver={(e) => {
                if (rejectionReason.trim()) e.currentTarget.style.backgroundColor = 'green';
              }}
              onMouseOut={(e) => {
                if (rejectionReason.trim()) e.currentTarget.style.backgroundColor = 'green';
              }}
            >
              Submit
            </button>
          </DialogActions>
      </Dialog>

    </>
  );
};

export default connect(null, { setLoading, setSnackInfo })(AdmCheckList);